import {Image} from 'expo-image'

/** Default renderer; web callers supply imageRendering: 'pixelated'. */
export const PixelArtImage = Image
